<template>
	<v-card class="pa-4 mb-2" rounded>
		<v-card-title>
			<v-btn icon color="primary">
				<v-icon>
					refresh
				</v-icon>
			</v-btn>
			Dispositivos de Emisión Offline
			<v-spacer/>
		</v-card-title>
		<v-card-text>
			<tabla-dispositivos ref="tabla" @openDialog="openDeshabilitar" @dispositivoDisabled="alreadyDisable" :dispositivos="dispositivos"></tabla-dispositivos>
			<modal-deshabilitar ref="dialog" @deshabilitar="deshabilitarDispositivo"></modal-deshabilitar>
			<v-snackbar
			v-model="alerta.display"
			:color="alerta.type"
			>
				{{ alerta.msg }}
			</v-snackbar>
		</v-card-text>
	</v-card>
</template>

<script>

import { API } from 'aws-amplify';
import { mapState } from 'vuex';

import ApiManager from '@/views/DispositivosOffline/ApiManager';
let apiConfiguracionUsuario = new ApiManager('apiConfiguracionUsuario');

import * as dateFns from 'date-fns';
import moment from 'moment';

import {tiposDte, diccionarioDte} from '@/vessi.utils.js';

import TablaDispositivos from './TablaDispositivos';
import ModalDeshabilitar from './ModalDeshabilitar';

export default {
	name: 'DispositivosOffline',
	components:{
		TablaDispositivos,
		ModalDeshabilitar
	},
	data () {
		return {
			dispositivos:[],
			alerta:{
				display:false,
				type:'',
				msg:''
			}
		}
	},
	methods:{
		getDataDispositivos: async function(){
			this.$refs.tabla.isloading=true;

			try{
				var response = await apiConfiguracionUsuario.post('/dispositivos-offline/get-dispositivos-contribuyente',{rut_contribuyente:this.$store.getters['empresas/seleccionada'].rut});
				this.dispositivos = response;
				this.$refs.tabla.isloading=false;
			}catch(err){
				this.$refs.tabla.isloading=false;
			}
		},
		openDeshabilitar: function(item){
			this.$refs.dialog.dispositivo = JSON.parse(JSON.stringify(item));
			this.$refs.dialog.openDialog=true;
		},
		deshabilitarDispositivo: async function(dispositivo){

			try{
				var responseDisable = await apiConfiguracionUsuario.post('/dispositivos-offline/disable-dispositivo',{rut_contribuyente:this.$store.getters['empresas/seleccionada'].rut,id_dispositivo:dispositivo});
				this.getDataDispositivos();
				this.mostrarAlerta('success','Dispositivo deshabilitado correctamente');
			}catch(err){
				this.mostrarAlerta('red darken-2','Error al deshabilitar el dispositivo');
			}
		},
		mostrarAlerta: function(tipo, msg){
			this.alerta.type = tipo;
			this.alerta.msg = msg;
			this.alerta.display = true;
		},
		alreadyDisable: function(){
			this.alerta.type = 'yellow darken-4';
			this.alerta.msg = 'El dispositivo ya se encuentra deshabilitado';
			this.alerta.display = true;
		}
	},
	mounted(){
		this.getDataDispositivos();
	}
}
</script>

<style lang="css" scoped>
</style>